/**
 * @generated SignedSource<<5fdd9a262af74c6a4bcad3e93574da77>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCascadingSelectField_Platform$data = {
  readonly cascadingOptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly childOptionValues: ReadonlyArray<{
          readonly optionId: string;
          readonly value: string | null;
        } | null> | null;
        readonly parentOptionValue: {
          readonly optionId: string;
          readonly value: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "JiraCascadingSelectField_Platform";
};
export type JiraCascadingSelectField_Platform$key = {
  readonly " $data"?: JiraCascadingSelectField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraCascadingSelectField_Platform">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "optionId"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraCascadingSelectField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "concreteType": "JiraCascadingOptionsConnection",
      "kind": "LinkedField",
      "name": "cascadingOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCascadingOptionsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCascadingOptions",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "parentOptionValue",
                  "plural": false,
                  "selections": (v0/*: any*/)
                },
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "childOptionValues",
                  "plural": true,
                  "selections": (v0/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraCascadingSelectField"
};
})();

(node as any).hash = "9cb0c614cdcec0cf84156c6af9d58dc3";

export default node;
